import { PosIconProps, SvgWrapper } from './SvgWrapper';

export const CompanionModeExitIcon = (props: Omit<PosIconProps, 'viewBox'>) => {
  return (
    <SvgWrapper viewBox="0 0 20 20" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.5 4C4.22386 4 4 4.22386 4 4.5V15.5688C4 15.8449 4.22386 16.0688 4.5 16.0688H15.5688C15.8449 16.0688 16.0688 15.8449 16.0688 15.5688V12.2125C16.0688 11.9364 16.2926 11.7125 16.5688 11.7125C16.8449 11.7125 17.0688 11.9364 17.0688 12.2125V15.5688C17.0688 16.3972 16.3972 17.0688 15.5688 17.0688H4.5C3.67157 17.0688 3 16.3972 3 15.5688V4.5C3 3.67157 3.67157 3 4.5 3H7.85626C8.13241 3 8.35626 3.22386 8.35626 3.5C8.35626 3.77614 8.13241 4 7.85626 4H4.5ZM16.4407 3.62759C16.6109 3.79771 16.6109 4.07354 16.4407 4.24366L12.457 8.22754L16.5688 8.22754C16.845 8.22754 17.0688 8.4514 17.0688 8.72754C17.0688 9.00368 16.845 9.22754 16.5688 9.22754L12.3413 9.22754C11.5129 9.22754 10.8413 8.55597 10.8413 7.72754L10.8413 3.50002C10.8413 3.22388 11.0652 3.00002 11.3413 3.00002C11.6175 3.00002 11.8413 3.22388 11.8413 3.50002V7.6111L15.8247 3.62759C15.9948 3.45747 16.2706 3.45747 16.4407 3.62759Z"
        fill="inherit"
      />
    </SvgWrapper>
  );
};
